import { Tenor } from "shared/cubiq-model-multi-asset";
import { CurrencyPairCalendarLookupService } from "shared/cubiq-services/lookup/model/impl/CurrencyPairCalendarLookupService";
import { EMPTY_TEXT_VALUE } from "../BaseTableDefinitionFactory";
import { ValueDateHelper } from "./ValueDateHelper";

export class ValueDateRenderer {
  static render(
    orderValueDate: any, // Moment
    orderTenor: Tenor,
    isSwap: boolean,
    isSSP: boolean,
    nearTenor: Tenor,
    nearValueDate: any, // Moment
    farTenor: Tenor,
    farValueDate: any, // Moment
    helper: ValueDateHelper,
  ): any {
    if (isSwap) {
      return helper.formatSwapValueDate(nearTenor, nearValueDate, farTenor, farValueDate);
    } else if (isSSP) {
      return "Multiple";
    } else if (helper) {
      return helper.formatValueDate(orderValueDate, orderTenor);
    }

    return EMPTY_TEXT_VALUE;
  }
}
